export const createStoreOptions = (stores) => {
    return (
        stores?.map((item) => ({
            value: item.storeCode,
            label: `${item.storeCode} ${item.storeName}`,
        })) ?? []
    );
};

export const createStoreOptionsWithoutSelected = (stores, rows, row, responseData) => {
    const selectedStoreCodes = rows.filter((item) => item.storeCode !== row.storeCode).map((item) => item.storeCode);
    const updateStoreCodes = responseData?.map((item) => item.storeCode);

    return (
        stores
            ?.filter((item) => !selectedStoreCodes?.includes(item.storeCode))
            .filter((item) => !updateStoreCodes?.includes(item.storeCode))
            .map((item) => ({
                value: item.storeCode,
                label: `${item.storeCode} ${item.storeName}`,
            })) ?? []
    );
};

export const createCompetitorChainOptions = (competitorChains) => {
    return (
        competitorChains?.map((item) => ({
            value: item.competitorChainCode,
            label: item.competitorChainName,
        })) ?? []
    );
};

export const createCompetitorStoreOptions = (competitorStores, selectedCompetitorChainCode) => {
    return (
        competitorStores
            ?.filter((item) => item.competitorStoreCode.startsWith(selectedCompetitorChainCode))
            .map((item) => ({
                value: item.competitorStoreCode,
                label: item.competitorStoreName,
            })) ?? []
    );
};

export const createCompetitorStoreOptionsWithoutSelected = (competitorStores, selectedCompetitorChainCode, rows, row, responseData) => {
    const selectedStoreCodes = rows
        .filter((item) => item.competitorStoreCode !== row.competitorStoreCode)
        .map((item) => item.competitorStoreCode);
    const updateStoreCodes = responseData?.map((item) => item.competitorStoreCode);

    return (
        competitorStores
            ?.filter((item) => item.competitorStoreCode.startsWith(selectedCompetitorChainCode))
            .filter((item) => !selectedStoreCodes?.includes(item.competitorStoreCode))
            .filter((item) => !updateStoreCodes?.includes(item.competitorStoreCode))
            .map((item) => ({
                value: item.competitorStoreCode,
                label: item.competitorStoreName,
            })) ?? []
    );
};

export const createCompetitorStoreOptionsWithoutChain = (competitorStores) => {
    return (
        competitorStores?.map((item) => ({
            value: item.competitorStoreCode,
            label: item.competitorStoreName,
        })) ?? []
    );
};

export const createCompetitorStoreMultiOptions = (competitorStores, selectedCompetitorChainCodes) => {
    return (
        competitorStores
            ?.filter((item) => selectedCompetitorChainCodes.some((code) => item.competitorStoreCode.startsWith(code)))
            .map((item) => ({
                value: item.competitorStoreCode,
                label: item.competitorStoreName,
            })) ?? []
    );
};

export const createDepartmentOptions = (departments) => {
    return departments.map((department) => ({
        value: department.value,
        label: department.label,
    }));
};
